import { Typography } from "@mui/material";
import React from "react";
import { Row, Col } from "react-bootstrap";
import InputAndOptions from "reusableComponent/formBuilder/InputandOptions";

const questionStyle = { fontSize: "16px", fontWeight: "medium" };

function AnswerForm({
  fullFormDetail,
  setAnswerResponse,
  selectedItem,
  validationErrors = {},
  onClearError,
  isView = false,
  ratingSummary,
}) {
  const localAnswers = React.useRef(
    JSON.parse(JSON.stringify(fullFormDetail || []))
  );

  const [questionDetails, setQuestionDetails] = React.useState(
    localAnswers.current
  );

  React.useEffect(() => {
    if (fullFormDetail?.length) {
      const updated = JSON.parse(JSON.stringify(fullFormDetail));
      localAnswers.current = updated;
      setQuestionDetails(updated);
    }
  }, [fullFormDetail]);

  const handleOnChange = (event, questionDetail, indexs) => {
    localAnswers.current = localAnswers.current.map((element) => {
      if (
        [
          "PARAGRAPH",
          "MULIPLE_CHOICE",
          "TIME",
          "DATE",
          "SHORT_ANS",
          "DROPDOWN",
          "RATING",
        ].includes(element.formType)
      ) {
        if (element.id === questionDetail.id) {
          if (event.target.value) onClearError?.(element.id);
          return { ...element, answer: event.target.value };
        }
      }

      if (element.formType === "CHECKBOX") {
        if (element.id === questionDetail.id) {
          const updatedOptions = element.options.map((opt, chkIdx) => {
            if (chkIdx === indexs) {
              return { ...opt, isChecked: event.target.checked };
            }
            return opt;
          });
          const anyChecked = updatedOptions.some((o) => o.isChecked);
          if (anyChecked) onClearError?.(element.id);
          return {
            ...element,
            options: updatedOptions,
            answer: updatedOptions,
          };
        }
      }

      return element;
    });

    setQuestionDetails([...localAnswers.current]);
    setAnswerResponse(localAnswers.current);
  };

  return (
    <React.Fragment>
      <section className="form_builder main_container">
        <Row className="d-flex justify-content-center">
          <Col md={10} lg={7} sm={12}>
            <div className="mt-3">
              {questionDetails?.map((form, idx) => {
                const hasError = validationErrors[form.id];
                return (
                  <div
                    id={`question-${form.id}`}
                    key={form.id}
                    className="bg_light rounded-2 mb-3"
                    style={hasError ? { border: "1.5px solid #e53935" } : {}}
                  >
                    <div className="p-4">
                      <Typography variant="div" sx={questionStyle}>
                        {form?.question}
                      </Typography>
                      {form?.requiredSwitch && (
                        <span className="text-danger"> *</span>
                      )}
                      <InputAndOptions
                        form={form}
                        requiredValidation={{}}
                        onChange={(e, f, i) => handleOnChange(e, f, i)}
                        idx={idx}
                        isView={isView}
                      />
                      {hasError && (
                        <div
                          style={{
                            color: "#e53935",
                            fontSize: "12px",
                            marginTop: "6px",
                          }}
                        >
                          This field is required
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </Col>
        </Row>
        {ratingSummary && isView && (
          <Row className="d-flex justify-content-center">
            <Col md={10} lg={7} sm={12}>
              <div className="bg_light rounded-2 mb-3 p-2">
                <b>{ratingSummary?.name}:</b>{" "}
                <b className="text-primary">{ratingSummary?.totalValue}</b>
                <b>/{ratingSummary?.totalStars}</b> (
                {ratingSummary?.percentage.toFixed(1)}%)
              </div>
            </Col>
          </Row>
        )}
      </section>
    </React.Fragment>
  );
}

export default React.memo(AnswerForm, (prevProps, nextProps) => {
  const errorsChanged =
    JSON.stringify(prevProps.validationErrors) !==
    JSON.stringify(nextProps.validationErrors);

  const ratingSummaryChanged =
    JSON.stringify(prevProps.ratingSummary) !==
    JSON.stringify(nextProps.ratingSummary);

  const formDetailChanged =
    JSON.stringify(prevProps.fullFormDetail) !==
    JSON.stringify(nextProps.fullFormDetail);

  return !errorsChanged && !ratingSummaryChanged && !formDetailChanged;
});
